/**
 * Dust Animation
 * @description Tworzy animację pyłu w sekcji.
 */
export function initDustAnimation(sectionSelector) {
  const section = document.querySelector(sectionSelector);
  const canvas = section?.querySelector("#dustCanvas");
  if (!canvas) return;

  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  let particles = [];
  let animationFrameId = null;

  function resizeCanvas() {
    canvas.width = section.clientWidth;
    canvas.height = section.clientHeight;
  }

  function generateParticles() {
    particles = [];
    for (let i = 0; i < 1000; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        size: Math.random() * 0.8 + 0.2,
        speedY: Math.random() * 0.8 + 0.4
      });
    }
  }

  let cursorX = 0;
  let cursorY = 0;

  function onMouseMove(e) {
    const rect = canvas.getBoundingClientRect();
    cursorX = e.clientX - rect.left;
    cursorY = e.clientY - rect.top;
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const gradient = ctx.createRadialGradient(cursorX, cursorY, 0, cursorX, cursorY, 150);
    gradient.addColorStop(0, "rgba(255,255,255,0.25)");
    gradient.addColorStop(1, "rgba(255,255,255,0)");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.save();
    ctx.beginPath();
    ctx.arc(cursorX, cursorY, 150, 0, Math.PI * 2);
    ctx.clip();

    for (let p of particles) {
      ctx.beginPath();
      ctx.fillStyle = "rgba(255,255,255,0.25)";
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();

      p.y += p.speedY;
      if (p.y > canvas.height) {
        p.y = 0;
        p.x = Math.random() * canvas.width;
      }
    }
    ctx.restore();
    animationFrameId = requestAnimationFrame(animate);
  }

  function start() {
    if (!animationFrameId) animate();
  }

  function stop() {
    cancelAnimationFrame(animationFrameId);
    animationFrameId = null;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  // Uruchamianie tylko, gdy sekcja widoczna
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        resizeCanvas();
        generateParticles();
        window.addEventListener("mousemove", onMouseMove);
        start();
      } else {
        window.removeEventListener("mousemove", onMouseMove);
        stop();
      }
    });
  }, { threshold: 0.4 });

  observer.observe(section);
}
